// modified from https://github.com/wmlgl/cropperjs-gif/blob/master/src/easy-gif.js
import GIF from 'gif.js.optimized';
import { parseGIF, decompressFrames } from 'gifuct-js';
import gifWorker from './GifWorker';
import BlobCreator from './BlobCreator';
var EasyGif = {
  fixCompatibility: function fixCompatibility() {
    GIF.prototype.getContextData = function (ctx) {
      var _ctx$getImageData = ctx.getImageData(0, 0, this.options.width, this.options.height),
          data = _ctx$getImageData.data;

      if (/CanvasPixelArray/.test(Object.prototype.toString.call(data))) {
        data = EasyGif.toUint8Array(data);
      }

      return data;
    };

    var _addFrame = GIF.prototype.addFrame;

    GIF.prototype.addFrame = function () {
      var ret = _addFrame.apply(this, arguments);

      var lastFrame = this.frames[this.frames.length - 1];

      if (lastFrame && lastFrame.data && /CanvasPixelArray/.test(Object.prototype.toString.call(lastFrame.data))) {
        lastFrame.data = EasyGif.toUint8Array(lastFrame.data);
      }

      return ret;
    };

    var sourceCode = GIF.prototype.finishRendering.toString();
    sourceCode = sourceCode.replace('new Blob', 'createBlob');
    GIF.prototype.finishRendering = new Function('createBlob', "return (".concat(sourceCode, ")"))(BlobCreator.createBlob);
  },
  toUint8Array: function toUint8Array(data) {
    return new Uint8Array(data);
  },
  frameToImageData: function frameToImageData(ctx, frame) {
    var totalPixels = frame.pixels.length;
    var imgData = ctx.createImageData(frame.dims.width, frame.dims.height);
    var patchData = imgData.data;

    for (var i = 0; i < totalPixels; i++) {
      var pos = i * 4;
      var colorIndex = frame.pixels[i];
      var color = frame.colorTable[colorIndex];
      patchData[pos] = color[0];
      patchData[pos + 1] = color[1];
      patchData[pos + 2] = color[2];
      patchData[pos + 3] = colorIndex !== frame.transparentIndex ? 255 : 0;
    }

    return imgData;
  },
  decoder: function decoder(arraybuffer) {
    var parsed = parseGIF(arraybuffer);
    return decompressFrames(parsed);
  },
  encoder: function encoder(options) {
    var workerJsAsBlob = new Blob([gifWorker], {
      type: 'application/javascript'
    });
    var workerScript = URL.createObjectURL(workerJsAsBlob);
    options.workerScript = workerScript;
    return new GIF(options);
  }
};
EasyGif.fixCompatibility();
export default EasyGif;